import { render } from "./MasterCourses.vue?vue&type=template&id=fe2dad68&scoped=true"
import script from "./MasterCourses.vue?vue&type=script&lang=js"
export * from "./MasterCourses.vue?vue&type=script&lang=js"

import "./MasterCourses.vue?vue&type=style&index=0&id=fe2dad68&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe2dad68"]])

export default __exports__